import React, { useMemo } from 'react';
import { Accordion, FilterList } from '@monorepo/ui-kit';
import { useSearchString } from '@monorepo/helpers';
import { useI18n } from '@monorepo/i18n';
import { FILTER_PARAMS } from '@monorepo/dictionary';
import type { TDictionaryFilter } from '@monorepo/type';

const CultureFilter: Component<TDictionaryFilter> = ({ onFilterSet, items }) => {
  const { t } = useI18n();
  const { getParamByName } = useSearchString();
  const cultureId = getParamByName(FILTER_PARAMS.cultureId, true);

  const filterItems = useMemo(() => {
    if (!items?.length) return [];

    const nameCounts = new Map<string, number>();
    items.forEach((item) => {
      const rawName = item.name.replace(` (${item.count})`, '');
      nameCounts.set(rawName, (nameCounts.get(rawName) || 0) + 1);
    });

    return items.map((item) => {
      const rawName = item.name.replace(` (${item.count})`, '');
      const hasCollision = (nameCounts.get(rawName) || 0) > 1;
      return {
        value: item.id.toString(),
        key: (item as any).key,
        label: hasCollision ? (
          <>
            {item.name}{' '}
            <span style={{ color: '#9ca3af', fontSize: '0.8em' }}>{t(`productTypes.${item.typeName}`)}</span>
          </>
        ) : item.name,
      };
    });
  }, [items]);

  return (
    <Accordion label={t('orders.filter.culture')} isDefaultOpen>
      <FilterList
        id={FILTER_PARAMS.cultureId}
        onChange={(val) => {
          onFilterSet(FILTER_PARAMS.cultureId, val);
        }}
        items={filterItems}
        defaultChecked={cultureId}
        isWithSearch={true}
      />
    </Accordion>
  );
};

export default CultureFilter;
